const vidEnded = _this => {
  _this.$nextTick(() => {
    if (_this.$refs.video) {
      _this.$refs.video.addEventListener("ended", () => {
        _this.showVideo = false;
      });
    }
  });
};

export default vidEnded;
